import { CalendarDate, isCalendarDate } from "./calendar-date";
import { formattedDateTime, formattedDateTimeDefault } from "./util/date";
import { Maybe } from "./util/maybe";
const isCalendarDateTime = (val) => {
    return val && val.isCalendarDateTime;
};
export class CalendarDateTime {
    constructor(date) {
        if (!date) {
            this._value = {
                hasTime: false,
                date: CalendarDate.fromDate(new Date()),
            };
        }
        else if (date instanceof Date) {
            if (isNaN(date.getTime())) {
                this._value = {
                    hasTime: false,
                    date: CalendarDate.fromDate(new Date()),
                };
            }
            else {
                this._value = {
                    hasTime: true,
                    date: date,
                };
            }
        }
        else {
            // CalendarDate is explicilty a type without a time
            // This value must be a CalendarDate value so it should not have a time
            this._value = {
                hasTime: false,
                date: date,
            };
        }
    }
    get dateString() {
        return this._value.hasTime
            ? this._value.date.toISOString().split("T")[0]
            : this._value.date.toString();
    }
    get timeString() {
        return this.toTimeString();
    }
    get withTime() {
        const result = new CalendarDateTime();
        result._value = { hasTime: true, date: new Date(this.date) };
        return result;
    }
    get withoutTime() {
        const result = new CalendarDateTime();
        result._value = { hasTime: false, date: CalendarDate.fromDate(this.date) };
        return result;
    }
    forTime(hours, minutes) {
        const result = this.withTime;
        if (!result._value.hasTime) {
            throw new Error("Unexpected withTime result");
        }
        result._value.date.setHours(hours);
        result._value.date.setMinutes(minutes);
        result._value.date.setSeconds(0);
        result._value.date.setMilliseconds(0);
        return result;
    }
    forDate(year, month, day) {
        if (this._value.hasTime) {
            const result = new CalendarDateTime();
            const date = new Date(this._value.date);
            date.setFullYear(year);
            date.setMonth(month - 1);
            date.setDate(day);
            result._value = { hasTime: true, date: date };
            return result;
        }
        return new CalendarDateTime(new CalendarDate(year, month, day));
    }
    get isCalendarDateTime() {
        return true;
    }
    get hasTime() {
        return this._value.hasTime;
    }
    get date() {
        return this._value.hasTime === true
            ? this._value.date
            : this._value.date.withTime(12);
    }
    get value() {
        return this._value;
    }
    toString() {
        return this._value.hasTime === true
            ? formattedDateTimeDefault(this._value.date)
            : this._value.date.toString();
    }
    toTimeString() {
        return this._value.hasTime === true
            ? formattedDateTime("HH:mm", this.date, "")
            : "";
    }
    static parse(val) {
        if (val === null || val === undefined || val === "") {
            return Maybe.none();
        }
        if (isCalendarDateTime(val)) {
            return Maybe.fromValue(val);
        }
        if (isCalendarDate(val)) {
            return Maybe.fromValue(new CalendarDateTime(val));
        }
        const str = val instanceof Date ? val.toISOString() : val;
        const [datePart, timePart] = str.split("T");
        if (datePart === null || datePart === undefined || datePart === "") {
            return Maybe.none();
        }
        if (timePart === null || timePart === undefined || timePart === "") {
            const segments = datePart.split("-").map(x => parseInt(x, 0));
            return Maybe.fromValue(new CalendarDateTime(new CalendarDate(segments[0], segments[1], segments[2])));
        }
        else {
            const parsed = new Date(str);
            if (isNaN(parsed.getTime())) {
                return Maybe.none();
            }
            return Maybe.fromValue(new CalendarDateTime(parsed));
        }
    }
}
//# sourceMappingURL=calendar-date-time.js.map